var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mobileHighLightedMarket } from '../../../services/sportsbook.services';
var MarketSelector = function (_a) {
    var marketGroup = _a.marketGroup, onSelect = _a.onSelect;
    var t = useTranslation().t;
    console.log("MarketSelector");
    var getInitialIndex = function () {
        if (!marketGroup)
            return 0;
        var idx = marketGroup.findIndex(function (g) { return g === mobileHighLightedMarket.selected; });
        return idx >= 0 ? idx : 0;
    };
    var _b = useState(getInitialIndex), activeIndex = _b[0], setActiveIndex = _b[1];
    if (!marketGroup || marketGroup.length === 0)
        return null;
    var handleSelect = function (group, index) {
        setActiveIndex(index);
        onSelect(group);
    };
    return (_jsx("div", __assign({ className: "main-tabs-bc", style: { overflowX: 'auto', overflowY: 'hidden', scrollbarWidth: 'none', marginBottom: '5px', position: 'sticky', top: '57px', zIndex: 100, background: 'rgba(var(--b), 1)' } }, { children: marketGroup.map(function (group, index) { return (_jsx("span", __assign({ className: "horizontal-sl-tab-bc ".concat(activeIndex === index ? 'active' : ''), onClick: function () { return handleSelect(group, index); } }, { children: t(group.name) }), "market-selector-".concat(index))); }) }), void 0));
};
export default MarketSelector;
